/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Dataprivacycheckbox2Inputs */

const en__field_dataprivacycheckbox2 = /** @type {(inputs: _Field_Dataprivacycheckbox2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I consent to the data privacy policy`)
};

const de__field_dataprivacycheckbox2 = /** @type {(inputs: _Field_Dataprivacycheckbox2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich willige in die Datenschutzerklärung ein`)
};

/**
* | output |
* | --- |
* | "I consent to the data privacy policy" |
*
* @param {_Field_Dataprivacycheckbox2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_dataprivacycheckbox2 = /** @type {((inputs?: _Field_Dataprivacycheckbox2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Dataprivacycheckbox2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_dataprivacycheckbox2(inputs)
	return de__field_dataprivacycheckbox2(inputs)
});
export { _field_dataprivacycheckbox2 as "_field_dataPrivacyCheckbox" }